import {
  TeamCategoryId,
  TeamCategoryTranslations,
} from "../../../types/team_categories.types";
import { TeamWithDetails } from "../../../types/team.types";
import { Building, Tag, Users } from "lucide-react";

interface ITeamInfoDisplayProps {
  team: TeamWithDetails;
}

export function TeamInfoDisplay({ team }: ITeamInfoDisplayProps) {
  return (
    <div className="grid grid-cols-2 gap-2">
    <p className="text-gray-800 flex flex-wrap items-center gap-1">
      <Users className="w-5 h-5 text-gray-600" />
      <span className="font-semibold">Nombre:</span> {team.name}
    </p>
    
    <p className="text-gray-800 flex flex-wrap items-center gap-1">
      <Building className="w-5 h-5 text-gray-600" />
      <span className="font-semibold">Barra Pesquera:</span>{" "}
      {team.institution?.name || "Sin Barra Pesquera"}
    </p>
    
    <div className="col-span-2 flex items-center gap-2 text-gray-800 flex-wrap">
      <Tag className="w-5 h-5 text-gray-600" />
      <span className="font-semibold">Categorías:</span>{" "}
      {team.categories && team.categories.length > 0 ? (
        team.categories.map((cat) => (
          <span
            key={cat.category_id}
            className="px-2 py-1 bg-blue-100 text-blue-800 rounded-lg text-sm"
          >
            {TeamCategoryTranslations[cat.category_id as TeamCategoryId]}
          </span>
        ))
      ) : (
        <span className="text-gray-500 italic">Sin categorías asignadas</span>
      )}
    </div>
  </div>
  
  );
}
